import React from "react";

import destination_1 from "../../public/wheretogo-beskydy/javorovy/destination_1.png";
import destination_2 from "../../public/wheretogo-beskydy/javorovy/destination_2.png";
import destination_3 from "../../public/wheretogo-beskydy/javorovy/destination_3.png";
import destination_4 from "../../public/wheretogo-beskydy/javorovy/destination_4.png";
import destination_5 from "../../public/wheretogo-beskydy/javorovy/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-beskydy/javorovy/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-beskydy/javorovy/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-beskydy/javorovy/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-beskydy/javorovy/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Javorovy = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Javorový vrch</h1>
            <p>
              Vrchol dosahuje výšky 1032 m. Směrem na východ, asi 1,5 km od něj,
              se nachází podvrchol Malý Javorový 948 m. Nachází se zde
              turistická chata, lyžařské sjezdovky, stanice horské služby,
              televizní stanice a velký kovový kříž.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>lyžařské sjezdovky</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>paragliding</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>turistická chata</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>tři světové strany</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Chata je vůbec nejstarší v Beskydech, protože ve své nezměněné
                  podobě, až na drobné rekonstrukce, stojí od roku 1895.
                </li>
                <li>
                  jeho mikroklima je natolik ojedinělé, že se tam daří ohroženým
                  druhům rostlin a hlavně živočichů. Můžete narazit třeba na
                  puštíka, strakapouda, ale i vzácné šelmy, jako je rys nebo vlk
                </li>
                <li>
                  Výstup na tento severní výběžek beskydského hřebene si
                  nenechala ujít řada významných osobností, například Tomáš
                  Garrigue Masaryk s dcerou Alicí nebo poslední rakouský císař
                  Karel I.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Javorovy;
